export function isRangeSetting(setting) {
  try {
    return 'Min' in setting && 'Max' in setting && 'Value' in setting;
  } catch (ex) {
    return false;
  }
}

export function isEnumSetting(setting) {
  try {
    return 'AllowedValues' in setting && Array.isArray(setting.AllowedValues) && 'Value' in setting;
  } catch (ex) {
    return false;
  }
}
